module.exports = __webpack_public_path__ + "img/龙湖@2x.d0563e57.png";